"use strict";

import PageCommon from "../PageCommon";

export default class Label extends PageCommon {
    constructor(props) {
        super();
        this.data = {
            ID: props.ID,
            Description: props.Description,
            Image: {
                High: props.Image.High,
                Medium: props.Image.Medium,
            },
            Name: props.Name,
            Tracks: props.Tracks,
            isNew: props.isNew,
        };
    }

    set(object) {
        this.data = Object.keys(this.data).map((field) => (this.data[field] = object[field]));
    }

    get() {
        return this.data;
    }

    renderSwiperListItem() {
        const modelId = "#model-artists-swiper-list";
        const item = document.querySelector(`${modelId} .swiper-slide`).cloneNode(true);
        item.dataset.id = this.data.ID;
        item.querySelector(".music-item-thumb").title = this.data.Name;
        item.querySelector(".music-item-thumb").href = this.setUrlParams("label/" + this._normalizza_track_prop(this.data.Name), [{ key: "id", value: this.data.ID }]);
        item.querySelector(".wrapper-img img").src = this.data.Image.Medium;
        item.querySelector(".wrapper-img img").alt = this.data.Name;
        item.querySelector(".name").textContent = this.data.Name;
        if (item.querySelector(".badge")) {
            if (!this.data.isNew) item.querySelector(".badge").style.display = "none";
            else item.querySelector(".badge").style.display = "";
        }
        return item;
    }

    renderListItem() {
        const modelId = "#model-artists-list";
        const item = document.querySelector(`${modelId} .artist-item`).cloneNode(true);
        item.dataset.id = this.data.ID;
        item.querySelector(".music-item-thumb").title = this.data.Name;
        item.querySelector(".music-item-thumb").href = this.setUrlParams("label/" + this._normalizza_track_prop(this.data.Name), [{ key: "id", value: this.data.ID }]);
        item.querySelector(".wrapper-img img").src = this.data.Image.Medium;
        item.querySelector(".wrapper-img img").alt = this.data.Name;
        item.querySelector(".name").innerHTML = this.data.Name;
        if (item.querySelector(".badge")) {
            if (!this.data.isNew) item.querySelector(".badge").style.display = "none";
            else item.querySelector(".badge").style.display = "";
        }
        return item;
    }

    renderSingleItem(container, tracks) {
        container.querySelector(".wrapper-img img").src = this.data.Image.Medium;
        container.querySelector(".wrapper-img img").alt = this.data.Name;
        container.querySelector(".album-name").textContent = this.data.Name;
        if (container.querySelector(".badge")) {
            if (!this.data.isNew) container.querySelector(".badge").style.display = "none";
            else container.querySelector(".badge").style.display = "";
        }
        if (this.data.Description) {
            container.querySelector(".album-bio p .full-description").innerHTML = this.data.Description;
        }

        const _this = this;
        container.querySelector(".wrapper-btns button.btn.share").addEventListener("click", (event) => {
            this.shareItem("label", _this.data);
        });

        // const list = document.querySelector("#tracksSection .tracks-list .tracks-list-body");
        // list.textContent = "";

        // if (this.data.Tracks) {
        //     this.data.Tracks.map((id) => {
        //         const track = tracks.get({ id });
        //         list.appendChild(tracks.getItem(track));
        //     });
        // }

        //  this.SetMeta(this.data);
    }

    // SetMeta(item) {
    //     document.querySelector('meta[property="og:title"]').setAttribute("content", item.Name);
    //     document.querySelector('meta[name="twitter:title"]').setAttribute("content", item.Name);
    //     document.querySelector('meta[name="title"]').setAttribute("content", item.Name);

    //     document.querySelector('meta[property="og:description"]').setAttribute("content", item.Name + "- Playlist");
    //     document.querySelector('meta[name="twitter:description"]').setAttribute("content", item.Name + "- Playlist");
    //     document.querySelector('meta[name="description"]').setAttribute("content", item.Name + "- Playlist");

    //     if (item.Image.Medium) {
    //         document.querySelector('meta[property="og:image"]').setAttribute("content", item.Image.Medium);
    //         document.querySelector('meta[name="twitter:image:src"]').setAttribute("content", item.Image.Medium);
    //     }
    // }

    dispose() {
        this.data = {};
    }
}
